import icon from 'vue-svgicon';

icon.register({
    'regular/road-woods': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20.25 12.013l-3 8.25h6l-3-8.25zM20.25 20.263v3M3.75.763l-3 8.25h6l-3-8.25zM3.75 9.013v3M1.1 23.263A20.256 20.256 0 0 1 21 6.763M11.189 23.263a10.531 10.531 0 0 1 4.4-5.25M5.749 23.263a12.53 12.53 0 0 1 .982-2.884"/><path pid="1" d="M8.388 17.605a9.951 9.951 0 0 1 .934-1.135 9.544 9.544 0 0 1 1.036-1.044M12.948 13.494a14.534 14.534 0 0 1 2.652-1.262" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
